import { render } from "./IphoneSwitch.vue?vue&type=template&id=398b1fb0&scoped=true"
import script from "./IphoneSwitch.vue?vue&type=script&lang=js"
export * from "./IphoneSwitch.vue?vue&type=script&lang=js"

import "./IphoneSwitch.vue?vue&type=style&index=0&id=398b1fb0&scoped=true&lang=css"

import exportComponent from "/home/misha/Рабочий стол/standart-system-front-student/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-398b1fb0"]])

export default __exports__